// iOS-specific utilities and enhancements

export const isIOS = (): boolean => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) || 
         (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};

export const isStandalone = (): boolean => {
  return window.matchMedia('(display-mode: standalone)').matches ||
         ('standalone' in window.navigator && (window.navigator as any).standalone);
};

export const getIOSVersion = (): number | null => {
  const match = navigator.userAgent.match(/OS (\d+)_/);
  return match ? parseInt(match[1], 10) : null;
};

// Safe area utilities for iOS notch/dynamic island
export const getSafeAreaInsets = () => {
  const style = getComputedStyle(document.documentElement);
  return {
    top: style.getPropertyValue('env(safe-area-inset-top)') || '0px',
    right: style.getPropertyValue('env(safe-area-inset-right)') || '0px',
    bottom: style.getPropertyValue('env(safe-area-inset-bottom)') || '0px',
    left: style.getPropertyValue('env(safe-area-inset-left)') || '0px'
  };
};

// Haptic feedback (requires HTTPS and user interaction)
export const hapticFeedback = {
  light: () => {
    if ('vibrate' in navigator && isIOS()) {
      navigator.vibrate(10);
    }
  },
  medium: () => {
    if ('vibrate' in navigator && isIOS()) {
      navigator.vibrate(20);
    }
  },
  heavy: () => {
    if ('vibrate' in navigator && isIOS()) {
      navigator.vibrate([30, 10, 30]);
    }
  },
  success: () => {
    if ('vibrate' in navigator && isIOS()) {
      navigator.vibrate([20, 5, 20]);
    }
  },
  warning: () => {
    if ('vibrate' in navigator && isIOS()) {
      navigator.vibrate([50, 25, 50]);
    }
  },
  error: () => {
    if ('vibrate' in navigator && isIOS()) {
      navigator.vibrate([100, 50, 100, 50, 100]);
    }
  }
};

// Prevent iOS bounce scrolling
export const preventIOSBounce = () => {
  document.addEventListener('touchmove', (e) => {
    if (e.touches.length > 1) {
      e.preventDefault();
    }
  }, { passive: false });
};

export const canInstallPWA = (): boolean => {
  return false;
};

export const showIOSInstallPrompt = () => {
  return;
};

// Status bar styling for iOS PWA
export const setIOSStatusBarStyle = (style: 'default' | 'black' | 'black-translucent' = 'default') => {
  let metaTag = document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]');
  
  if (!metaTag) {
    metaTag = document.createElement('meta');
    metaTag.setAttribute('name', 'apple-mobile-web-app-status-bar-style');
    document.head.appendChild(metaTag);
  }
  
  metaTag.setAttribute('content', style);
};

// Initialize iOS-specific features
export const initializeIOSFeatures = () => {
  if (!isIOS()) return;
  
  // Set status bar style
  setIOSStatusBarStyle('black-translucent');
  
  // Prevent bounce scrolling
  preventIOSBounce();
  
  localStorage.setItem('ios-install-prompt-seen', 'true');
};